import { Box, Link } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import ImgBg from "../../assets/images/products/Backgroundcrypto.svg";

interface Props {
  title: string;
  link: string;
}

const CryptoOfferingArticle: React.FC<Props> = ({ title, link }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: 200,
        backgroundImage: `url(${ImgBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "1.5rem 1.25rem",
      }}
    >
      <Box sx={{ fontSize: 30, lineHeight: 1.2, fontWeight: 600 }}>{title}</Box>
      <Box>
        <Link href={link}>
          <Box sx={{ fontSize: 16, lineHeight: 1.2, color: "#fff" }}>
            <ChevronRightIcon />
            Learn More
          </Box>
        </Link>
      </Box>
    </Box>
  );
};

export default CryptoOfferingArticle;
